import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const RegisterPage = () => {
    useEffect(() => {
        // Open register modal when directly accessing this page
        document.dispatchEvent(new CustomEvent('open-register-modal'));
    }, []);

    return <Navigate to="/" replace />;
};

export default RegisterPage; 